const initKeyState = () =>{
  return {
    objCmsUserKeys: [],
    objVesselKeys: [],
    objVesselTypeKeys : [],
    objManningKeys: [],
    objRankKeys: [],
    objCrewKeys : [],
  }
}

/** state **/
const state = {
  ...initKeyState()
};


/** mutations **/
const mutations = {
  //region set object keys
  set_cms_user_keys(state, payload) {
    state.objCmsUserKeys = payload;
  },

  set_vessel_keys(state, payload) {
    state.objVesselKeys = payload;
  },

  set_vessel_type_keys(state,payload){
    state.objVesselTypeKeys = payload
  },

  set_manning_keys(state, payload) {
    state.objManningKeys = payload;
  },

  set_rank_keys(state, payload) {
    state.objRankKeys = payload;
  },

  set_crew_keys(state,payload){
    state.objCrewKeys = payload;
  },
  //endregion

  //region reset object keys
  reset_cms_user_keys(state,payload){
    state.objCmsUserKeys = []
  },

  reset_vessel_keys(state,payload){
    state.objVesselKeys = []
  },

  reset_vessel_type_keys(state,payload){
    state.objVesselTypeKeys = payload
  },

  reset_manning_keys(state,payload){
    state.objManningKeys = payload;
  },

  reset_rank_keys(state,payload){
    state.objRankKeys = payload;
  },

  reset_key_objects(state) {
    Object.assign(state,initKeyState())
  }
  //endregion
};

/** actions **/
const actions = {
  set_cms_user_keys({commit}){
    commit('set_cms_user_keys')
  },

  set_vessel_keys({commit}){
    commit('set_vessel_keys')
  },

  set_vessel_type_keys({commit}){
    commit('set_vessel_type_keys')
  },

  set_manning_keys({commit}){
    commit('set_manning_keys')
  },

  set_rank_keys({commit}){
    commit('set_rank_keys')
  },

  reset_cms_user_keys({commit}){
    commit('reset_cms_user_keys')
  },

  reset_vessel_keys({commit}){
    commit('reset_vessel_keys')
  },

  reset_vessel_type_keys({commit}){
    commit('reset_vessel_type_keys')
  },

  reset_manning_keys({commit}){
    commit('reset_manning_keys')
  },

  reset_rank_keys({commit}){
    commit('reset_rank_keys')
  },

  resetKeyObjects({commit}){
    commit('reset_key_objects');
  }
};

/** getters **/
const getters = {
  objCmsUserKeys: state => state.objCmsUserKeys,
  objVesselKeys: state => state.objVesselKeys,
  objVesselTypeKeys: state => state.objVesselTypeKeys,
  objManningKeys: state => state.objManningKeys,
  objRankKeys: state => state.objRankKeys,
  objCrewKeys: state => state.objCrewKeys,
};

/** export **/
export default {state, actions, mutations, getters};
